import React, { useContext, useState } from 'react'
import MainPageNav from "../MainPageHome/MainPageNav"
import MainPageBody from './MainPageBody'
import MainPageListing from './MainPageListings/MainPageListing'
import "./Mainpage.css"
import 'animate.css';
import Hot from './Hot/Hot'
import Losers from './Losers/Losers'
import Gainers from './Gainers/Gainers'
import Favorites from './Favorites/Favorites'
import NewListings from './NewListings/NewListings'
import { SwitchACtiveContext } from '../Context/StartTrackingContext/SwitchActiveContext'
import MarketFooter from "../HomeMarket/MarketFooter/MarketFooter"
import { Helmet } from 'react-helmet-async'

function MainPage() {
  const [ active , setActive ] = useState("Hot")
  const { 
          showLosers,
          showGainers,
          showFavorites,
          showNewListings,
         } = useContext(SwitchACtiveContext)
const image = "https://static.vecteezy.com/system/resources/previews/000/543/841/non_2x/blue-wave-surface-blockchain-technology-and-science-abstract-background-music-equalizer-of-hexagon-network-wire-frame-illumination-texture-pattern-new-technology-particle-digital-concept-wallpaper-vector.jpg"
  return (
    <div className='mainpage'>
        <Helmet >
        <title>Home</title>
        <meta name="description" content="Access up to date lists of crypto gainers and losers, as well as new listings, in order to make smart investments."/>
        <link rel="canonical" href="/" />
      </Helmet>
      <div className='krypto_inc'>
        <h1 className='animate__animated animate__backInRight'>© 2024 Krypto, Inc.</h1>
      </div>
        <div className='market_footer'>
          <MarketFooter/>
        </div>

      <div className='mainpage_nav'>
        <MainPageNav/>
      </div>
      <div className='mainpage_body'>
        <img className='main_body_image' src={image} alt="" />
          <div className='main_page_body'>
          <MainPageBody />
          </div>
      </div>
      <div className='MainPageListing_body'>
        <MainPageListing 
        setActive={setActive}
        active={active}
        />
      </div>
      <div className='mainpage_body_container'>
        
            {active === "Hot" && <div className='Hot_body'>
              <Hot />
            </div>}

            {showLosers && <div className='Losers_body'>
              <Losers />
            </div>}

            {showGainers && <div className='Gainers_body'>
              <Gainers />
            </div>}

            {showFavorites && <div className='Favorites_body'>
              <Favorites />
            </div> }

            {showNewListings && <div className='NewListings_body'>
              <NewListings />
            </div>}
            
      </div>

    </div>
  )
}

export default MainPage
